module.exports = __webpack_public_path__ + "media/MRI5B.438cc607.mp3";